import script from "./DonorRecognitionAndBenefitStructureView.vue?vue&type=script&setup=true&lang=js"
export * from "./DonorRecognitionAndBenefitStructureView.vue?vue&type=script&setup=true&lang=js"

import "./DonorRecognitionAndBenefitStructureView.vue?vue&type=style&index=0&id=152d5c14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-152d5c14"]])

export default __exports__